var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.71429H1.25C0.918479 7.71429 0.600537 7.84974 0.366116 8.09086C0.131696 8.33198 0 8.65901 0 9C0 9.34099 0.131696 9.66802 0.366116 9.90914C0.600537 10.1503 0.918479 10.2857 1.25 10.2857H3.75V16.7143C3.75 17.0553 3.8817 17.3823 4.11612 17.6234C4.35054 17.8645 4.66848 18 5 18C5.33152 18 5.64946 17.8645 5.88388 17.6234C6.1183 17.3823 6.25 17.0553 6.25 16.7143V10.2857H8.75C9.08152 10.2857 9.39946 10.1503 9.63388 9.90914C9.8683 9.66802 10 9.34099 10 9C10 8.65901 9.8683 8.33198 9.63388 8.09086C9.39946 7.84974 9.08152 7.71429 8.75 7.71429ZM23.75 0H8.75C8.41848 0 8.10054 0.135459 7.86612 0.376577C7.6317 0.617695 7.5 0.944722 7.5 1.28571C7.5 1.62671 7.6317 1.95373 7.86612 2.19485C8.10054 2.43597 8.41848 2.57143 8.75 2.57143H15V16.7143C15 17.0553 15.1317 17.3823 15.3661 17.6234C15.6005 17.8645 15.9185 18 16.25 18C16.5815 18 16.8995 17.8645 17.1339 17.6234C17.3683 17.3823 17.5 17.0553 17.5 16.7143V2.57143H23.75C24.0815 2.57143 24.3995 2.43597 24.6339 2.19485C24.8683 1.95373 25 1.62671 25 1.28571C25 0.944722 24.8683 0.617695 24.6339 0.376577C24.3995 0.135459 24.0815 0 23.75 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/textIcon.0c297c89c6a1d26d41d5586127550846.svg";
export { ForwardRef as ReactComponent };